var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTowerCameraOptical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 16.8435C1.45 16.8435 0.979167 16.6477 0.5875 16.256C0.195833 15.8643 0 15.3935 0 14.8435V2.84351C0 2.29351 0.195833 1.82267 0.5875 1.43101C0.979167 1.03934 1.45 0.843506 2 0.843506H14C14.55 0.843506 15.0208 1.03934 15.4125 1.43101C15.8042 1.82267 16 2.29351 16 2.84351V7.34351L20 3.34351V14.3435L16 10.3435V14.8435C16 15.3935 15.8042 15.8643 15.4125 16.256C15.0208 16.6477 14.55 16.8435 14 16.8435H2ZM2 14.8435H14V2.84351H2V14.8435Z",
    fill: "#FF0953"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowerCameraOptical);
export default __webpack_public_path__ + "static/media/tower_camera_optical.1e3db32ccc5552fd8ff1bfec57d4ae63.svg";
export { ForwardRef as ReactComponent };